export default __webpack_public_path__ + "static/media/logo-apple.ca32a70e.svg";